// extracted by mini-css-extract-plugin
export default {"marker":"map-point-icon_marker__gX6BE","plane":"map-point-icon_plane__wdp8H"};